/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2023-08-25 17:10:23
 * @LastEditors: geory
 * @LastEditTime: 2026-02-26 10:26:51
 */
import httpRequest from "./request";

const http = {
  //查询素材图片集合
  querySucaiImageListMore(data) {
    return httpRequest.post("/group/web/dynamic/image/list.do", data, {
      isUnEncrypt: false,
      isEncryptResponse: true,
    });
  },
  //删除 定时任务
  delTask(data) {
    return httpRequest.post("/group/web/dynamic/delTask.do", data, {
      isUnEncrypt: true,
      isEncryptResponse: true,
    });
  },
  //保存 定时素材v2
  saveTaskSucai(data) {
    return httpRequest.post("/group/web/dynamic/saveTaskV2.do", data);
  },
  //复用 素材v2
  reuseSucai(data) {
    return httpRequest.post("/group/web/dynamic/copy.do", data, {
      isUnEncrypt: true,
      isEncryptResponse: true,
    });
  },
  //删除 素材v2
  delSucai(data) {
    return httpRequest.post("/group/web/dynamic/del.do", data, {
      isUnEncrypt: true,
      isEncryptResponse: true,
    });
  },
  //保存 素材v2
  saveSucai(data) {
    return httpRequest.post("/group/web/dynamic/saveV2.do", data);
  },
  //查询标签列表
  queryTagList(data) {
    return httpRequest.post("/group/web/dynamic/tag/queryList.do", data, {
      isUnEncrypt: true,
      isEncryptResponse: true,
    });
  },
  //获取上传上传凭证
  getCosUploadInfo(data) {
    return httpRequest.post("/group/web/tencent/getTmpKey.do", data, {
      isUnEncrypt: true,
      isEncryptResponse: true,
    });
  },
  //查询 分类列表
  queryCategoryList(data) {
    return httpRequest.post("/group/web/dynamic/label/queryList.do", data, {
      isUnEncrypt: true,
      isEncryptResponse: true,
    });
  },
  //查询 团队列表
  queryTeamList(data) {
    return httpRequest.post("/group/web/team/queryList.do", data);
  },
  //查询 素材列表
  querySucaiList(data) {
    return httpRequest.post("/group/web/dynamic/queryList.do", data, {
      isUnEncrypt: true,
    });
  },
  //查询 任务列表
  queryTaskList(data) {
    return httpRequest.post("/group/web/dynamic/queryTaskList.do", data, {
      isUnEncrypt: true,
    });
  },
  //手机号码登录
  getLoginCode(data) {
    return httpRequest.post("/group/web/user/login.do", data, {
      isUnEncrypt: true,
    });
  },
  //发送验证码
  sendMegCode(data) {
    return httpRequest.post("/group/web/user/sendSms.do", data, {
      isUnEncrypt: true,
    });
  },
  //查询二维码
  createQrCode(data) {
    return httpRequest.post("/group/web/user/queryQrCode.do", data, {
      isUnEncrypt: true,
    });
  },
  //二维码登录
  loginByCode(data) {
    return httpRequest.post("/group/web/user/loginByQrCode.do", data, {
      isUnEncrypt: true,
    });
  },
};

export default http;
